import { ajax } from 'rxjs/ajax';
import { switchMap, take } from 'rxjs/operators';
import { jsonHeaders$ } from './headers';
import { combineLatest } from 'rxjs';
import { memberId$ } from './subjects';
import { MemberPlanResponse } from 'interfaces/api/MemberPlanResponse';

const planService = {
    get$: (planYear?: number) =>
        combineLatest(jsonHeaders$, memberId$).pipe(
            switchMap(([headers, memberId]) =>
                ajax<MemberPlanResponse>({
                    method: 'GET',
                    url: `api/enrollment/members/${memberId}/plans${
                        planYear ? `?planYear=${planYear}` : ``
                    }`,
                    headers,
                })
            ),
            take(1)
        ),
};

export default planService;
